const cards = [
  {
    title: '斗破苍穹',
    tag: '玄幻热血',
    desc: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，种种打击接踵而至。就在他即将绝望之际，一缕灵魂从他手上的戒指里浮现...',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20manga%20cover%20illustration%20featuring%20a%20young%20warrior%20with%20flame%20powers%20holding%20a%20heavy%20ruler%20weapon%2C%20martial%20arts%20fantasy%20theme%2C%20warm%20orange%20and%20gold%20color%20scheme%2C%20dynamic%20action%20pose%2C%20clean%20minimal%20background%2C%20modern%20anime-inspired%20art%20style&width=400&height=560&seq=card-01&orientation=portrait',
  },
  {
    title: '一人之下',
    tag: '异能都市',
    desc: '普通大学生张楚岚因爷爷坟墓被盗而卷入异人世界，为了查明爷爷死亡的真相，他参加了龙虎山的罗天大醮...',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20manga%20cover%20illustration%20featuring%20a%20mysterious%20urban%20exorcist%20with%20a%20casual%20modern%20outfit%2C%20supernatural%20city%20theme%2C%20warm%20amber%20and%20deep%20red%20color%20scheme%2C%20cool%20confident%20pose%2C%20clean%20minimal%20background%2C%20modern%20anime-inspired%20art%20style&width=400&height=560&seq=card-02&orientation=portrait',
  },
  {
    title: '完美世界',
    tag: '东方玄幻',
    desc: '一粒尘可填海，一根草斩尽日月星辰。石昊生于大荒，天资绝世却命运多舛，漫漫修行路上他能否逆天改命...',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20manga%20cover%20illustration%20featuring%20an%20ancient%20cultivator%20child%20with%20mystical%20beast%20companion%2C%20eastern%20fantasy%20mythology%20theme%2C%20warm%20coral%20and%20jade%20green%20color%20scheme%2C%20adventurous%20pose%2C%20clean%20minimal%20background%2C%20modern%20anime-inspired%20art%20style&width=400&height=560&seq=card-03&orientation=portrait',
  },
  {
    title: '全职高手',
    tag: '电竞竞技',
    desc: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因种种原因被俱乐部驱逐，他带着十年游戏经验重新投入游戏...',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20manga%20cover%20illustration%20featuring%20a%20confident%20esports%20player%20with%20gaming%20headset%2C%20competitive%20gaming%20theme%2C%20warm%20bronze%20and%20cyan%20color%20scheme%2C%20focused%20determined%20expression%2C%20clean%20minimal%20background%2C%20modern%20anime-inspired%20art%20style&width=400&height=560&seq=card-04&orientation=portrait',
  },
  {
    title: '镇魂街',
    tag: '奇幻冒险',
    desc: '普通应届毕业生夏铃在求职之际意外收到一条奇怪的面试通知，踏入罗刹街后她的命运从此彻底改变...',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20manga%20cover%20illustration%20featuring%20a%20guardian%20spirit%20warrior%20in%20ancient%20armor%2C%20supernatural%20adventure%20theme%2C%20warm%20copper%20and%20crimson%20color%20scheme%2C%20heroic%20protective%20stance%2C%20clean%20minimal%20background%2C%20modern%20anime-inspired%20art%20style&width=400&height=560&seq=card-05&orientation=portrait',
  },
  {
    title: '狐妖小红娘',
    tag: '恋爱奇幻',
    desc: '世上有人有妖，妖会与人相恋。涂山狐妖以红娘为职业，为前世恋人牵红线续今生缘，一段段跨越轮回的爱情故事...',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20manga%20cover%20illustration%20featuring%20a%20beautiful%20fox%20spirit%20matchmaker%20girl%2C%20romantic%20fantasy%20theme%2C%20warm%20pink%20and%20gold%20color%20scheme%2C%20elegant%20pose%20with%20magical%20ribbon%2C%20clean%20minimal%20background%2C%20modern%20anime-inspired%20art%20style&width=400&height=560&seq=card-06&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-heading text-2xl md:text-3xl text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-600">51漫画网编辑团队精心挑选的必读佳作</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, idx) => (
            <div key={idx} className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all group">
              <div className="flex">
                <div className="w-[120px] flex-shrink-0 overflow-hidden">
                  <img src={card.cover} alt={card.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="flex-1 p-4 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <h3 className="text-base font-semibold text-foreground-900">{card.title}</h3>
                    <span className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded-md text-xs font-medium flex-shrink-0">{card.tag}</span>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-4">{card.desc}</p>
                  <div className="mt-2 flex items-center gap-2">
                    <a
                      href="#ranking"
                      onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                      className="text-xs text-primary-500 font-medium no-underline cursor-pointer hover:text-primary-600 flex items-center gap-1"
                    >
                      查看榜单 <i className="ri-arrow-right-line text-xs"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}